// extracted by mini-css-extract-plugin
module.exports = {"header":"_5c2a703","body":"_32aec73","text":"_f588304","button":"_0f4936f"};